<template>
    <b-container
            v-if="isLoaded"
            class="relais px-0 d-flex flex-column"
    >
        <main
                id="roadlog-container"
                class="flex-grow-1 d-flex flex-column"
                :class="{'br-4 block--shadow border-0': isDesktop}"
        >
            <div class="relais--tab d-flex flex-column flex-grow-1 pt-1">
                <b-card class="relais--tab-card flex-grow-1 d-flex flex-column">
                    <b-card-header class="p-0 relais--tab-header" header-tag="nav">
                        <b-nav tabs fill class="relais--tab-nav">
                            <b-nav-item
                                    class="relais--tab-nav-item"
                                    v-on:click="tab = 'meetings'"
                                    :active="tab === 'meetings'"
                            >
                                <i class="fas fa-users"></i>
                                Séances
                                <span
                                        v-if="counts.meetingType > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.meetingType}}
                                </span>
                            </b-nav-item>
                            <b-nav-item
                                    class="relais--tab-nav-item"
                                    v-on:click="tab = 'coaches'"
                                    :active="tab === 'coaches'"
                            >
                                <i class="fas fa-comments"></i>
                                Coach
                                <span
                                        v-if="counts.threads.length > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.threads.length}}
                                </span>
                            </b-nav-item>
                            <b-nav-item
                                    class="relais--tab-nav-item"
                                    v-on:click="tab = 'reminders'"
                                    :active="tab === 'reminders'"
                            >
                                <i class="fas fa-bullhorn"></i>
                                Rappels
                                <span
                                        v-if="counts.reminders > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.reminders}}
                                </span>
                            </b-nav-item>
                        </b-nav>
                    </b-card-header>
                    <b-card-body class="relais--tab--body flex-grow-1 flex-column px-0">
                        <div
                                class="relais--tab--body-meetings d-flex flex-column"
                                v-if="tab === 'meetings' && seanceTypes.actives && seanceTypes.incoming"
                        >
                            <h2 class="pt-2"> Séances types proposées</h2>
                            <template v-if="seanceTypes.actives.length > 0">
                                <h3 class="relais--tab--body-title">
                                    <template v-if="coachName">Le coach {{coachName}} vous a préparé ces séances
                                    </template>
                                    <template v-else>Le coach vous a préparé ces séances</template>
                                </h3>
                                <meeting-type-detail
                                        v-for="(meeting, index) of seanceTypes.actives"
                                        :meeting-type="meeting"
                                        :key="`meeting-type-active-${index}`"
                                />
                            </template>
                            <template v-if="seanceTypes.incoming.length > 0">
                                <h3 class="relais--tab--body-title">Séances à venir ...</h3>
                                <meeting-type-detail
                                        v-for="(meeting, index) of seanceTypes.incoming"
                                        :meeting-type="meeting"
                                        :key="`meeting-type-incoming-${index}`"
                                />
                            </template>
                            <b-alert
                                    :show="seanceTypes.actives.length === 0 && seanceTypes.incoming.length === 0"
                                    class="mx-auto mt-1"
                            >
                                Aucune séance n'est diponible pour le moment
                            </b-alert>
                        </div>
                        <div
                                class="relais--tab--body-coaches d-flex flex-column"
                                v-else-if="tab === 'coaches'"
                        >
                            <thread-detail
                                    v-if="queryThreadId"
                                    :thread-id="queryThreadId"
                                    :update-size="updateThreadSize"
                                    @click="pickThread($event)"
                            />
                            <thread-list
                                    v-else
                                    class="flex-grow-1"
                                    @change="pickThread($event)"
                                    :auto-pick="autoPickThread"
                                    default-thread
                            />
                        </div>
                        <div
                                class="relais--tab--body-reminders"
                                v-else-if="tab === 'reminders'"
                        >
                            <h2 class="pt-2">
                                Vos rappels et informations
                                <a href="#"><i class="fas fa-info-circle"></i></a>
                            </h2>
                            <roadlog-reminder
                                    v-for="(reminder, index) of reminders"
                                    :key="`roadlog-relais-reminder-${index}`"
                                    :reminder="reminder"
                                    @done="loadReminders()"
                            />
                            <b-alert class="text-center my-2" :show="reminders.length === 0">
                                Vous n'avez aucun rappels à effectuer pour le moment
                            </b-alert>
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </main>
    </b-container>
</template>

<style lang="scss" scoped>
    .relais--tab-card {
        .card-body {
            padding: 0 !important;
        }
    }
</style>

<script>
    import NavigationTabs from "../../components/navigation/Tabs";
    import ThreadList from "../../components/thread/List";
    import ThreadDetail from "../../components/thread/Detail";
    import MeetingTypeDetail from "../../components/meetingType/Detail";
    import RoadlogReminder from "../../components/roadlog/Reminder";

    export default {
        name: 'RelaisRoadlog',
        components: {RoadlogReminder, MeetingTypeDetail, ThreadDetail, ThreadList, NavigationTabs},
        data: () => ({
            tab: 'meetings',
            autoPickThread: true,
            updateThreadSize: false,
            loaded: [],
            isLoaded: false,
            isDesktop: window.innerWidth > 768
        }),
        async mounted() {
            this.tab = this.queryTab
            await this.loadCounts()
            if (this.queryThreadId) {
                this.tab = 'coaches'
            } else {
                this.loadMeetings()
            }
            this.isLoaded = true
        },
        methods: {
            pickThread(threadId) {
                this.queryThreadId === threadId ?
                    this.$router.push({query: {}}) :
                    this.$router.push({query: {threadId: threadId}})
                this.autoPickThread = false
            },
            async loadMeetings() {
                await Promise.all([
                    this.$store.dispatch('base/seanceType/listeRelais'),
                    this.$store.dispatch('base/organisation/role', {
                        role: 'ROLE_COACH_REFERENT',
                        ous: this.$store.state.base.account.mainOrganisationId
                    })
                ])
            },
            async loadCoaches() {
                await this.reloadThreads()
            },
            async loadReminders() {
                await this.$store.dispatch('base/report/todo')
            },
            async loadCounts() {
                await this.$store.dispatch('base/appInterface/roadlog', {
                    role: 'ROLE_WORKER_RELAIS',
                    ouId: null
                })
            },
            async reloadThreads() {
                await this.$store.dispatch('base/thread/list', null)
            },
        },
        computed: {
            reminders() {
                let reminders = []
                if (this.reportsTodo.length > 0) {
                    const reportTodo = this.reportsTodo[0]
                    reminders.push({
                        name: 'Rapport hebdomadaire à effectuer',
                        info: `Du ${reportTodo.dateStart} au ${reportTodo.dateEnd}`,
                        icon: 'fas fa-clipboard-list',
                        isImportant: true,
                        date: reportTodo.dateStart,
                        report: reportTodo,
                        button: {
                            label: 'Effectuer le rapport',
                            modal: {
                                id: 'reportRelais',
                                query: {}
                            }
                        }
                    })
                }
                return reminders
            },
            reportsTodo() {
                return this.$store.state.base.report.todo
            },
            queryTab() {
                return this.$route.query.tab ? this.$route.query.tab : 'meetings'
            },
            coaches() {
                return this.$store.state.base.organisation.usersByRole
            },
            coachName() {
                return this.coaches.length > 0 ? this.coaches[0].firstname : false
            },
            queryThreadId() {
                return this.$route.query.threadId ?
                    parseInt(this.$route.query.threadId) :
                    undefined
            },
            seanceTypes() {
                return this.$store.state.base.seanceType.seanceTypes
            },
            counts() {
                return this.$store.state.base.appInterface.roadlog
            },
            threads() {
                return this.$store.state.base.thread.threads
            },
            user() {
                return this.$store.state.base.account.information
            }
        },
        watch: {
            tab() {
                this.updateThreadSize = this.tab === 'coaches'
                if (!this.loaded.includes(this.tab)) {
                    switch (this.tab) {
                        case 'meetings':
                            this.loadMeetings()
                            break
                        case 'coaches':
                            this.loadCoaches()
                            break
                        case 'reminders':
                            this.loadReminders()
                            break
                    }
                    this.loaded.push(this.tab)
                }
            }
        }
    }
</script>
